<template>
  <div>
    <div class="home-container">
      <div class="hx-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>供应系统</el-breadcrumb-item>
          <el-breadcrumb-item>基地管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'availabilityReport' }">供应力上报</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ name: 'record' }">历史记录</el-breadcrumb-item>
          <el-breadcrumb-item>历史记录详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <div style="line-height: 30px; font-weight: 500" class="mgl20">
            <span>领货日期：</span>
            <span class="alert-text" v-if="deliveryTakenDate">{{ deliveryTakenDate | formatDate(true) }}</span>
          </div>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <hx-table-result :show-pager-on-one-page="false" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <el-table slot="content" :data="tableData" max-height="800" border>
          <el-table-column prop="goodsId" align="center" fixed label="序号"> </el-table-column>

          <el-table-column prop="title" align="center" fixed label="产品名称"> </el-table-column>

          <el-table-column prop="spec" align="center" fixed label="规格"> </el-table-column>

          <el-table-column prop="stockTotal" align="center" label="基地供应能力">
            <!--<template slot-scope="scope">-->
            <!--<el-input size="small" v-model="scope.row.stockTotal"></el-input>-->
            <!--</template>-->
          </el-table-column>

          <el-table-column prop="little" align="center" label="富余量"> </el-table-column>

          <el-table-column align="center" v-for="(item, index) in columnList" :key="index" :label="item.title">
            <template slot-scope="scope">
              <span>{{ scope.row.list[index] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dateId: "",
      deliveryTakenDate: "",
      dateList: [],
      columnList: [],
      logisticsSiteIdList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
    };
  },
  created() {
    this.dateId = this.$route.query.dateId;
    this.loadColumnTitle();
  },
  methods: {
    /**
     * 初始化表头
     */
    loadColumnTitle() {
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-name?dateId=" + this.dateId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.columnList = res.body.data.list;
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      const bodyParams = {
        farmId: parseInt(this.$route.params.baseId),
        dateId: this.$route.query.dateId,
      };
      this.$http({
        url: global.apiUrl + "/farm/farm-stock-history-info",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
              this.deliveryTakenDate = res.body.data.supplyDate;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
